module.exports = __webpack_public_path__ + "static/media/sfl_12.6f3c3b58.jpg";